import { render, staticRenderFns } from "./LegalParameterList.vue?vue&type=template&id=7ec8fe6c"
import script from "./LegalParameterList.vue?vue&type=script&lang=js"
export * from "./LegalParameterList.vue?vue&type=script&lang=js"
import style0 from "./LegalParameterList.vue?vue&type=style&index=0&id=7ec8fe6c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports